export const slug = "pending-approvals";
export const title = "Pending Approvals";
export const section = "Core";
export const content = `
# Pending Approvals

The Pending Approvals page collects profile changes that clients submitted through the client portal and are waiting for staff review before going live.

## What Triggers a Pending Item

A pending approval is created when a client submits a change through the client portal, such as:

- Updated home address
- New or changed phone number or email
- Changes to household members (added, removed, or edited)

These changes are **not applied automatically** — a staff member must approve them first to protect data integrity.

## Reviewing a Change

Each pending item shows:

- The **client's name** and when the change was submitted.
- A **diff view** highlighting exactly what changed (old value on the left, new value on the right).

## Approving a Change

Click **Approve** to apply the client's submitted change to their record. The change is saved and the client receives a confirmation the next time they log in to the portal.

## Rejecting a Change

Click **Reject** if the change appears incorrect (e.g., the address does not look valid). You may optionally add a note explaining why. The client's record remains unchanged.

## Tips

- Approvals and rejections are recorded in the audit log with the reviewing staff member's name.
- The Dashboard counter shows how many pending approvals are waiting. Staff receive a notification badge in the sidebar as well.
- Bulk approval is available via the checkboxes on the left — select multiple items and click **Approve Selected**.
`;
